import {Payload} from '../../../payload/payload';
import {HttpClient} from '@angular/common/http';
import {BaseActionService} from './baseAction.service';
import {environment} from '../../../../../../../environments/environment';

export abstract class AbstractActionNoCacheService<P extends Payload, Result> extends BaseActionService<P, Result> {

    protected constructor(baseUrl: string,
                          actionName: string,
                          httpClient: HttpClient) {
        super(environment.webserviceUrl + '/' + baseUrl + '/action-' + actionName, httpClient);
    }
}
